import { FieldValues, useForm, UseFormHandleSubmit} from "react-hook-form";
import {
    TageaFormProps,
    UseTageaFormRegister, UseTageaFormReturn,
} from "@web-libs/core/forms/application/use-tagea-form.types";
import {mapErrorToMessage} from "@web-libs/core/forms/application/map-form-error-to-message";
import {_useDisableSubmit} from "@web-libs/core/forms/application/_use_disable_submit";
import {_useServerError} from "@web-libs/core/forms/application/_use-server-error";
import {useDictionaryContext} from "@web-libs/core/internationalization/dictionary.context";


export function useTageaForm<
    TFieldValues extends FieldValues = FieldValues,
    TContext = any,
    TTransformedValues extends FieldValues | undefined = undefined
>(props?: TageaFormProps<TFieldValues, TContext>): UseTageaFormReturn<TFieldValues, TContext, TTransformedValues> {
    const useFormConcern= useForm<TFieldValues>(props);
    const {formState} = useFormConcern;
    const {errors} = formState;
    const dict = useDictionaryContext()
    const registerField: UseTageaFormRegister<TFieldValues> = (name, label, options) => {
        const {register} = useFormConcern
        return {
            label,
            ...register(name, options),
            error: mapErrorToMessage(dict, errors[name], options)
        }
    }

    const {setError} = useFormConcern
    const {serverError, setSubmissionErrorHandler, handleServerError} = _useServerError(formState,setError)

    const _handleSubmit: UseFormHandleSubmit<TFieldValues, TTransformedValues> = (onSubmit, onInvalid) => {
        const {handleSubmit} = useFormConcern
        return handleSubmit(
            async (data, event) => {
                try {
                    await onSubmit(data, event);
                } catch (e) {
                    handleServerError(e)
                }
            },
            (errors, event) => {
                if (onInvalid)
                    onInvalid(errors, event);

            }
        );
    }

    const disableSubmit = _useDisableSubmit(formState)

    const {getValues, setValue, reset, watch, unregister} = useFormConcern

    return {
        register: registerField,
        disableSubmit,
        handleSubmit: _handleSubmit,
        registerServerErrorMapper: setSubmissionErrorHandler,
        serverError: serverError,
        getValues,
        watch,
        unregister,
        formState,
        setValue,
        reset,
        clearErrors: useFormConcern.clearErrors,
        setError: useFormConcern.setError,
        trigger: useFormConcern.trigger
    };
}
